<template>
  <el-dialog
    title="地图黑名单"
    :visible.sync="showDialog"
    width="60%"
    :before-close="closeDialog"
    v-loading="loading"
  >
    <div class="tags">
      <el-input
        type="textarea"
        v-model="dynamicTags"
        placeholder="请输入uin，用,分隔"
        clearable
        rows="10"
      ></el-input>
    </div>
    <template #footer>
      <span>
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { saveMapBlackList, getMapBlackList } from '@/api/charts';
export default {
  name: 'mapBlackList',
  props: {
    show: { type: Boolean, default: false },
    mapId: { type: String, default: '' },
  },
  data() {
    return {
      showDialog: false,
      dynamicTags: '',
      loading: false,
    };
  },
  mounted() {
    this.showDialog = this.show;
  },
  watch: {
    show(val) {
      this.showDialog = val;
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
      this.dynamicTags = '';
      this.$emit('close');
    },
    getList() {
      this.loading = true;
      getMapBlackList({
        aid: this.mapId,
      })
        .then(res => {
          if (res.code === 0) {
            this.dynamicTags = res.data?.list.join(',') || '';
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      if (!this.mapId) {
        return this.$message.error('地图id不存在');
      }
      saveMapBlackList({
        aid: this.mapId,
        uin_list: this.dynamicTags,
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功');
            this.closeDialog();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tag {
  margin-left: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 20px;
  width: 160px;
}
.input-new-tag {
  width: 160px;
  margin-left: 10px;
  vertical-align: bottom;
  margin-top: 20px;
}
div.tags {
  height: auto;
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
